import * as React from 'react';
import * as ReactDOM from 'react-dom';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import configureStore from './store';
import { createBrowserHistory } from 'history';
import rootSaga from './saga';

import './styles/index.scss';
import App from './components/app/App';

import Tracker from '@openreplay/tracker';

import { actionCreators as authActionCreators, actionTypes as authActionTypes } from './reducers/Auth';
import { actionCreators as layoutActionCreators } from './reducers/Layout';
import LoginResponse from './models/LoginResponse';
import { ConnectedRouter } from 'connected-react-router';
import SecondWindowService from './service/SecondWindowService';
import testConfig from './feature-config';
import { decode } from 'jsonwebtoken';
import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

const asayerCode = process.env.REACT_APP_ASAYER_CODE;

if (asayerCode) {
    new Tracker({ projectKey: asayerCode }).start();
}

const history = createBrowserHistory();

history.listen((location) => {
    const mount = document.getElementById('context-menu-portal');
    mount.innerHTML = '';
    mount.style.top = '-2000px';
});

const sagaMiddleware = createSagaMiddleware();

const checkTokenExpirationMiddleware = (s: MiddlewareAPI<Dispatch<AnyAction>>) => (n: Dispatch<AnyAction>) => (a: AnyAction) => {
    if (a.type !== authActionTypes.LOGOUT) {
        const t = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');

        const expKey = 'exp';

        const deserializedToken = decode(t);
        if (deserializedToken && deserializedToken[expKey] < Date.now() / 1000) {
            console.log('token', deserializedToken[expKey], Date.now());
            s.dispatch(authActionCreators.logout());
        }
    }
    n(a);
};

const store = configureStore([checkTokenExpirationMiddleware, sagaMiddleware], history);
SecondWindowService.initialize(store);
sagaMiddleware.run(rootSaga);

const token = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');
const persist: boolean = localStorage.getItem('jwt') ? true : false;

if (token !== undefined && token !== 'undefined' && token !== null) {
    const encodedTokenClaims = token.split('.')[1];
    const tokenClaims = JSON.parse(window.atob(encodedTokenClaims.replace('-', '+').replace('_', '/')));
    if (!tokenClaims.tfj) {
        const login = new LoginResponse();
        login.jwt = token;
        login.persistSession = persist;
        // check token is still valid
        store.dispatch(authActionCreators.loginSuccess(login));
    } else {
        localStorage.removeItem('jwt');
        sessionStorage.removeItem('jwt');
    }
}

// Check if window is Second Window
const parser = location;
if (parser.search.indexOf('sw=true') >= 0) {
    store.dispatch(layoutActionCreators.setIsSecondWindow());
}
const rootEl = document.getElementById('root') as HTMLElement;

// Check for test variable
if (testConfig.testingMode === true) {
    store.dispatch(layoutActionCreators.setTestingMode());
}

// --- Global 403 interceptor for fetch --- //
const originalFetch = window.fetch;

window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.url.includes(process.env.REACT_APP_BASE_API_URL || '')) {
        if (response.status === 403) {
            if (!window.location.pathname.startsWith('/forbidden')) {
                console.warn('Encountered a 403 — redirecting to /forbidden');
                store.dispatch({ type: '@@router/CALL_HISTORY_METHOD', payload: { method: 'push', args: ['/forbidden'] } });
                return Promise.reject(response);
            }
        }
    }

    // if (response.status === 401) {
    //     console.warn('Encountered a 401 — redirecting to /login');

    //     // call logout to flush any cached tokens etc.
    //     store.dispatch(authActionCreators.logout());
    //     store.dispatch({ type: '@@router/CALL_HISTORY_METHOD', payload: { method: 'push', args: ['/login'] } });

    //     // throw to discard any awaiting useFetch() calls.
    //     throw new Error('Forbidden');
    // }

    return response;
};

// tslint:disable-next-line
const renderApp = (Component: any) => {
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Component />
            </ConnectedRouter>
        </Provider>,
        rootEl
    );
};

renderApp(App);

// if (module.hot) {
//   module.hot.accept('./components/app/App', () => {
//     return renderApp(App);
//   });
// }



// WEBPACK FOOTER //
// ./src/index.tsx